import React from "react";

const NoCapability = () => {
  return (
    <svg
      aria-hidden="true"
      width="47"
      height="47"
      viewBox="0 0 47 47"
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.234 38.4468H2.87234C1.72272 38.4468 1 37.6604 1 36.5745V2.87234C1 1.78638 1.72272 1 2.87234 1H38.4468C39.5964 1 40.3191 1.78638 40.3191 2.87234V13.1702"
        stroke="url(#paint0_linear_1313_32620)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.503"
        d="M15.9785 24.4174H5.68066M18.787 29.0982H9.42534M15.9785 33.7791H11.2977"
        stroke="#333333"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.787 10.3748H5.68066"
        stroke="#A2A2A2"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.503"
        d="M15.9786 19.7365H10.3616M19.7233 15.0557H8.48926M35.6382 15.0557H24.4041"
        stroke="#AAAAAA"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.503"
        d="M33.7663 45.0001C39.9707 45.0001 45.0003 39.9704 45.0003 33.766C45.0003 27.5616 39.9707 22.532 33.7663 22.532C27.5619 22.532 22.5322 27.5616 22.5322 33.766C22.5322 39.9704 27.5619 45.0001 33.7663 45.0001Z"
        stroke="url(#paint1_linear_1313_32620)"
        strokeWidth="3"
      />
      <path
        opacity="0.503"
        d="M33.7654 42.1915C29.1121 42.1915 25.3398 38.4193 25.3398 33.766C25.3398 29.1127 29.1121 25.3405 33.7654 25.3405"
        stroke="#989898"
        strokeLinecap="round"
      />
      <path
        d="M33.7656 35.6383L33.7656 30.0212"
        stroke="#9F9F9F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.7721 38.4656C34.0204 38.4656 34.2585 38.5642 34.4341 38.7398C34.6096 38.9153 34.7083 39.1535 34.7083 39.4017C34.7083 39.65 34.6096 39.8882 34.4341 40.0637C34.2585 40.2393 34.0204 40.3379 33.7721 40.3379C33.5238 40.3379 33.2857 40.2393 33.1101 40.0637C32.9346 39.8882 32.8359 39.65 32.8359 39.4017C32.8359 39.1535 32.9346 38.9153 33.1101 38.7398C33.2857 38.5642 33.5238 38.4656 33.7721 38.4656Z"
        fill="#9F9F9F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.3065 16.9973C40.6033 18.0477 40.843 18.2817 41.9074 18.5682C40.8448 18.8622 40.608 19.0981 40.3178 20.1503C40.0201 19.1009 39.7813 18.8659 38.716 18.5785C39.7785 18.2855 40.0154 18.0486 40.3065 16.9973ZM22.2506 19.1009C22.5474 20.1513 22.7871 20.3853 23.8515 20.6727C22.7889 20.9667 22.5521 21.2026 22.2619 22.2548C21.9642 21.2045 21.7245 20.9695 20.6601 20.6821C21.7226 20.39 21.9595 20.1531 22.2506 19.1009ZM17.654 36.876C17.9517 37.9263 18.1914 38.1604 19.2558 38.4468C18.1923 38.7408 17.9555 38.9767 17.6643 40.029C17.3676 38.9795 17.1288 38.7445 16.0635 38.4571C17.126 38.1641 17.3648 37.9273 17.655 36.875L17.654 36.876Z"
        stroke="#D4D4D4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.505"
        d="M5.68129 6.61697C6.19832 6.61697 6.61746 6.19783 6.61746 5.6808C6.61746 5.16377 6.19832 4.74463 5.68129 4.74463C5.16425 4.74463 4.74512 5.16377 4.74512 5.6808C4.74512 6.19783 5.16425 6.61697 5.68129 6.61697Z"
        fill="#333333"
      />
      <path
        opacity="0.505"
        d="M8.4889 6.61697C9.00594 6.61697 9.42507 6.19783 9.42507 5.6808C9.42507 5.16377 9.00594 4.74463 8.4889 4.74463C7.97187 4.74463 7.55273 5.16377 7.55273 5.6808C7.55273 6.19783 7.97187 6.61697 8.4889 6.61697Z"
        fill="#333333"
      />
      <path
        opacity="0.505"
        d="M11.2975 6.61697C11.8145 6.61697 12.2337 6.19783 12.2337 5.6808C12.2337 5.16377 11.8145 4.74463 11.2975 4.74463C10.7805 4.74463 10.3613 5.16377 10.3613 5.6808C10.3613 6.19783 10.7805 6.61697 11.2975 6.61697Z"
        fill="#333333"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1313_32620"
          x1="38.1752"
          y1="2.91055"
          x2="4.92522"
          y2="42.5464"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F7F7" />
          <stop offset="0.44808" stopColor="#9F9F9F" />
          <stop offset="1" stopColor="#9E9E9E" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1313_32620"
          x1="43.7752"
          y1="23.6783"
          x2="23.6786"
          y2="46.4939"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F7F7F7" />
          <stop offset="0.44808" stopColor="#9F9F9F" />
          <stop offset="1" stopColor="#9E9E9E" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default NoCapability;
